<template>
  <div class="payload-media" :class="isMe() ? 'me' : 'other'">
    <table>
      <tr v-if="isMe()">
        <td>
          <!-- <div v-if="isDelivered()" class="time inline">
            {{ conversation.createdAt | timeChatFormat }}
          </div> -->
          <div class="time inline">
            {{ conversation.createdAt | timeChatFormat }}
          </div>
          <!-- <div v-if="isDeliverFailed()" class="failed-icon inline">
            <v-tooltip top>
              <template #activator="{ on }">
                <v-icon color="red" v-on="on">mdi-alert-circle</v-icon>
              </template>
              <span>Failed</span>
            </v-tooltip>
          </div> -->
          <Media :payload="conversation.message.payload" />
          <!-- <div v-if="conversation.message.deliver" class="progress-bar">
            <deliver-reaction
              :deliver="conversation.message.deliver"
              @onResendMedia="resendMedia"
              @onRemoveMediaDeliver="removeMediaDeliver"
            />
          </div> -->
        </td>
      </tr>
      <tr v-else>
        <td class="fix-width"><div class="logo-small"></div></td>
        <td>
          <Media :payload="conversation.message.payload" />
          <div class="time inline">
            {{ conversation.createdAt | timeChatFormat }}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Media from './components/media'
// import DeliverReaction from './components/deliverReaction'
import Const from '@/utils/const'
export default {
  name: 'PayloadMedia',
  components: {
    Media
    // DeliverReaction
  },
  props: {
    conversation: Object
  },
  methods: {
    isMe() {
      return this.conversation.sender === 'customer'
    },
    isDelivered() {
      let delivered = true
      if (
        this.conversation.message.deliver &&
        this.conversation.message.deliver.status !=
          Const.MessageDeliverStatus.SUCCEED
      ) {
        delivered = false
      }
      return delivered
    },
    isDeliverFailed() {
      return (
        this.conversation.message.deliver &&
        this.conversation.message.deliver.status ==
          Const.MessageDeliverStatus.FAILED
      )
    },
    removeMediaDeliver({ deliverId }) {
      this.$emit('onRemoveMediaDeliver', { deliverId })
    },
    resendMedia({ deliverId }) {
      this.$emit('onResendMedia', { deliverId })
    }
  }
}
</script>
